export enum FileProvidersFilter {
    None,
    InsertLinkBusiness,
    InsertLinkConsumer,
}
